import {
  AddAWNotificationSubscriptionDto,
  ApprovalWorkflowControllerCountApprovalWorkflowsParams,
  ApprovalWorkflowControllerDeleteParams,
  ApprovalWorkflowControllerGetApprovalWorkflowParams,
  ApprovalWorkflowControllerListApprovalWorkflowsParams,
  ApprovalWorkflowControllerListPotentialManagersParams,
  ApprovalWorkflowControllerListPotentialReviewerGroupsParams,
  ApprovalWorkflowControllerListPotentialReviewersParams,
  AssetAwCommentsControllerDeleteAssetCommentParams,
  AssetAwCommentsControllerGetAssetCommentParams,
  AssetAwCommentsControllerGetAssetCommentsParams,
  AssetAwCommentsControllerListCommentPotentialMentionsParams,
  CreateAWCommentDto,
  CreateAWDto,
  ReplyAWCommentDto,
  RequestParams,
  RestartAWDto,
  SendAWInvitationsDto,
  SetAWCommentLikeDto,
  SetAWCommentResolveDto,
  SplitAWDto,
  SubmitDecisionDto,
  UpdateAWCommentDto,
  UpdateAWDto
} from '@api/Api';
import { apiClient } from '@api/client';

export const getApprovalWorkflow = (
  data: ApprovalWorkflowControllerGetApprovalWorkflowParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerGetApprovalWorkflow(
    data,
    params
  );

export const createApprovalWorkflow = (data: CreateAWDto) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerCreate(data);

export const restartApprovalWorkflow = (data: RestartAWDto) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerRestart(data);

export const sendReminderMemberApprovalStage = (data: SendAWInvitationsDto) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerSendInvitations(data);

export const deleteApprovalWorkflow = (
  params: ApprovalWorkflowControllerDeleteParams
) => apiClient.approvalWorkflow.approvalWorkflowControllerDelete(params);

export const decisionApprovalWorkflow = (params: SubmitDecisionDto) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerSubmitDecision(params);

export const updateApprovalWorkflow = (params: UpdateAWDto) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerUpdate(params);

export const approvalWorkflowSplit = (params: SplitAWDto) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerSplit(params);

export const getPotentialsApprovalReviewers = (
  data: ApprovalWorkflowControllerListPotentialReviewersParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerListPotentialReviewers(
    data,
    params
  );

export const getPotentialsApprovalReviewerGroups = (
  data: ApprovalWorkflowControllerListPotentialReviewerGroupsParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerListPotentialReviewerGroups(
    data,
    params
  );

export const getPotentialsApprovalManagers = (
  data: ApprovalWorkflowControllerListPotentialManagersParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerListPotentialManagers(
    data,
    params
  );

export const getCountApprovalWorkflows = (
  data: ApprovalWorkflowControllerCountApprovalWorkflowsParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerCountApprovalWorkflows(
    data,
    params
  );

export const getListApprovalWorkflows = (
  data: ApprovalWorkflowControllerListApprovalWorkflowsParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerListApprovalWorkflows(
    data,
    params
  );

export const approvalWorkflowAddNotificationSubscription = (
  params: AddAWNotificationSubscriptionDto
) =>
  apiClient.approvalWorkflow.approvalWorkflowControllerAddNotificationSubscription(
    params
  );

export const assetAwCommentsCreateAssetComment = (params: CreateAWCommentDto) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerCreateAssetComment(
    params
  );

export const assetAwCommentsReplyAssetComment = (params: ReplyAWCommentDto) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerReplyAssetComment(params);

export const assetAwCommentsDeleteAssetComment = (
  params: AssetAwCommentsControllerDeleteAssetCommentParams
) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerDeleteAssetComment(
    params
  );

export const assetAwCommentsUpdateAssetComment = (params: UpdateAWCommentDto) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerUpdateAssetComment(
    params
  );

export const assetAwCommentsSetAssetCommentLike = (
  params: SetAWCommentLikeDto
) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerSetAssetCommentLike(
    params
  );

export const assetAwCommentsSetAssetCommentResolve = (
  params: SetAWCommentResolveDto
) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerSetAssetCommentResolve(
    params
  );

export const assetAwCommentsListCommentPotentialMentions = (
  params: AssetAwCommentsControllerListCommentPotentialMentionsParams
) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerListCommentPotentialMentions(
    params
  );

export const assetAwCommentsGetAssetComments = (
  data: AssetAwCommentsControllerGetAssetCommentsParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerGetAssetComments(
    data,
    params
  );

export const assetAwCommentsGetAssetComment = (
  data: AssetAwCommentsControllerGetAssetCommentParams,
  params: RequestParams = {}
) =>
  apiClient.approvalWorkflow.assetAwCommentsControllerGetAssetComment(
    data,
    params
  );
